<template>
  <div class="z-[4] !fixed bottom-0">
    <div
      class="w-full flex justify-around bg-white px-4 pt-4 md:hidden pb-[2.5rem]!"
    >
      <router-link
        v-for="(tab, i) in [
          {
            name: 'Accueil',
            icon: 'kingrecharges.svg',
            id: 'home'
          },
          { name: 'Carte Bancaire', icon: 'card.svg', id: 'cards' },
          { name: 'Paiements', icon: 'online-payment.svg', id: 'payments' },
          { name: 'Convertir', icon: 'exchange_2_.svg', id: 'converter' },
          { name: 'Aujourd\'hui', icon: 'news.svg', id: 'ads' }
        ]"
        :key="i"
        :to="`${tab.id}`"
        class="flex flex-col items-center gap-3 rounded-2xl duration-300"
        :class="{
          'text-[#010101]': $route.name == tab.id,
          'text-[#ccc]': $route.name !== tab.id
        }"
      >
        <ColorImg :src="`/images/all/${tab.icon}`" class="w-7 h-7 bg-current" />
        <div class="w-[19vw] text-center text-xs">
          {{ tab.name }}
        </div>
      </router-link>
    </div>
  </div>
</template>
